const mdsc = {
  FORMS: [],
  CSS: {
    id: '6539305b57fda35f933b2d02',
    name: 'mdsc',
    avatar: {
      name: 'Chatbot',
      header: 'https://chatbotqa.gatblac.com/static/avatar/mdsc/avatar-inactivo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/mdsc/avatar-new.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/mdsc/avatar-activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/mdsc/avatar-inactivo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#10069F',
        borderColor: '#10069F'
      }
    }
  }
}

export default mdsc
